import {Pipe, PipeTransform} from '@angular/core';

@Pipe({ name: 'ternary' })
export class TernaryPipe implements PipeTransform {
  transform(value: boolean, trueValue: any, falseValue: any): any { return value ? trueValue : falseValue; }
}
